import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useAlert } from '../../contexts/AlertContext';

const Container = styled.div`
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  background: rgba(255, 255, 255, 0.1);
  padding: 20px;
  border-radius: 15px;
  backdrop-filter: blur(10px);
`;

const Title = styled.h1`
  color: white;
  margin: 0;
  font-size: 2.5rem;
  font-weight: 700;
`;

const Button = styled.button`
  background: rgba(255, 255, 255, 0.2);
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  color: white;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: translateY(-2px);
  }
`;

const Card = styled.div`
  background: rgba(255, 255, 255, 0.1);
  padding: 25px;
  border-radius: 15px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  margin-bottom: 20px;
`;

const CardTitle = styled.h3`
  color: white;
  margin: 0 0 20px 0;
  font-size: 1.5rem;
  font-weight: 600;
`;

const PlaceholderCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 40px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  border: 1px solid #e9ecef;
  text-align: center;
`;

const Icon = styled.div`
  font-size: 64px;
  margin-bottom: 20px;
`;

const Description = styled.p`
  font-size: 16px;
  color: #6c757d;
  line-height: 1.6;
  margin-bottom: 30px;
`;

const FeatureList = styled.ul`
  list-style: none;
  padding: 0;
  text-align: left;
  max-width: 500px;
  margin: 0 auto;
`;

const FeatureItem = styled.li`
  padding: 8px 0;
  color: #495057;
  
  &:before {
    content: '🔍';
    margin-right: 10px;
  }
`;

const QualityManagement = () => {
  const { addAlert } = useAlert();

  const handleNewInspection = () => {
    addAlert({
      type: 'quality',
      severity: 'low',
      title: 'New Inspection Started',
      message: 'Quality inspection process initiated',
      category: 'quality'
    });
  };

  return (
    <Container>
      <Header>
        <Title>🔬 Quality Management</Title>
        <Button onClick={handleNewInspection}>
          ➕ New Inspection
        </Button>
      </Header>

      <Card>
        <CardTitle>Quality Control Dashboard</CardTitle>
        <p style={{ color: 'rgba(255, 255, 255, 0.8)' }}>
          Comprehensive quality management system for commodity verification, testing protocols, 
          and certification tracking across all warehouse locations.
        </p>
      </Card>

      <PlaceholderCard>
        <Icon>✅</Icon>
        <h2 style={{ margin: '0 0 20px 0' }}>Quality Assurance</h2>
        <Description>
          Comprehensive quality management system for commodity verification, 
          testing, and certification to ensure highest standards.
        </Description>
        
        <FeatureList>
          <FeatureItem>Quality inspection workflows</FeatureItem>
          <FeatureItem>Laboratory testing management</FeatureItem>
          <FeatureItem>Certification and compliance tracking</FeatureItem>
          <FeatureItem>Quality metrics and analytics</FeatureItem>
          <FeatureItem>Supplier quality assessments</FeatureItem>
          <FeatureItem>Non-conformance management</FeatureItem>
        </FeatureList>
      </PlaceholderCard>
    </Container>
  );
};

export default QualityManagement; 